{
    "executive": {
        "title": "لوحة الإدارة التنفيذية",
        "subtitle": "الوحدات الأربع في صفحة واحدة، من أرقام تُحسب وفق جدول.",
        "computed_at": "الأرقام حتى {{time}}",
        "scoped": "تغطي هذه الأرقام الفروع التي تملك صلاحية الاطلاع عليها، لا البنك كاملاً."
    },
    "filters": {
        "from": "من",
        "to": "إلى",
        "apply": "تطبيق"
    },
    "cards": {
        "trend": "الاتجاه",
        "no_comparison": "لا توجد فترة قابلة للمقارنة",
        "points": "{{points}} نقطة",
        "base_one": "سجل واحد",
        "base_two": "سجلان",
        "base_few": "{{count}} سجلات",
        "base_many": "{{count}} سجلاً",
        "base_other": "{{count}} سجل",
        "complaints_received": "الشكاوى المستلمة",
        "complaints_sla_breached": "تجاوزات المهلة",
        "queue_tickets": "زيارات الفروع",
        "queue_wait_seconds": "متوسط زمن الانتظار",
        "cc_contacts": "الاتصالات المعالجة",
        "cc_abandoned": "الاتصالات المهجورة",
        "cc_first_contact_resolution": "الحل من أول اتصال",
        "survey_responses": "ردود الاستبيانات",
        "survey_nps": "مؤشر صافي الترويج"
    },
    "map": {
        "title": "على مستوى السلطنة",
        "by_branch": "حسب الفرع",
        "branch": "الفرع",
        "no_data": "لا توجد بيانات",
        "base_one": "سجل واحد",
        "base_two": "سجلان",
        "base_few": "{{count}} سجلات",
        "base_many": "{{count}} سجلاً",
        "base_other": "{{count}} سجل"
    },
    "reports": {
        "title": "التقارير",
        "subtitle": "أسئلة محفوظة، وإجابات عند الطلب.",
        "new": "تقرير جديد",
        "built_in": "مدمج",
        "run": "تشغيل",
        "last_run": "آخر تشغيل {{date}}"
    },
    "builder": {
        "new": "تقرير جديد",
        "subtitle": "اختر ما تريد قياسه، وكيف تجمّعه، وما تستثنيه.",
        "what": "ما الذي يُقاس",
        "dataset": "البيانات",
        "measures": "المقاييس",
        "group_by": "التجميع حسب",
        "no_dimensions": "بلا تجميع — صف واحد يحمل الإجماليات.",
        "filters": "المرشّحات",
        "value": "القيمة",
        "details": "بيانات التقرير",
        "key": "المُعرّف",
        "name_en": "الاسم (بالإنجليزية)",
        "name_ar": "الاسم (بالعربية)",
        "visualisation": "نوع الرسم",
        "row_limit": "حد الصفوف",
        "visibility": "من يراه",
        "sharing_note": "مشاركة التقرير تشارك السؤال لا الإجابة — كل من يفتحه يرى البيانات المسموح له بها فقط.",
        "preview": "معاينة",
        "preview_note": "{{count}} صفاً في {{ms}} مللي ثانية",
        "pick_a_measure": "اختر مقياساً واحداً على الأقل لعرض المعاينة.",
        "system_readonly": "هذا تقرير مدمج. صدّره، أو انسخه وعدّل النسخة."
    },
    "visibility": {
        "private": "أنا فقط",
        "public": "الجميع",
        "roles": "أدوار محددة"
    },
    "visualisations": {
        "table": "جدول",
        "bar": "أعمدة",
        "line": "خط بياني",
        "pie": "قطاعات",
        "heatmap": "خريطة حرارية",
        "kpi": "رقم واحد"
    },
    "grains": {
        "day": "يوم",
        "week": "أسبوع",
        "month": "شهر",
        "quarter": "ربع",
        "year": "سنة"
    },
    "operators": {
        "equals": "يساوي",
        "not_equals": "لا يساوي",
        "in": "أحد",
        "not_in": "ليس أحد",
        "greater_than": "أكبر من",
        "greater_or_equal": "لا يقل عن",
        "less_than": "أقل من",
        "less_or_equal": "لا يزيد عن",
        "between": "بين",
        "contains": "يحتوي",
        "starts_with": "يبدأ بـ",
        "is_null": "فارغ",
        "not_null": "غير فارغ"
    },
    "datasets": {
        "complaints": "الشكاوى",
        "interactions": "المسار الزمني للعميل",
        "queue_tickets": "زيارات الفروع",
        "survey_responses": "ردود الاستبيانات",
        "conversations": "مركز الاتصال"
    },
    "table": {
        "empty": "لا توجد صفوف مطابقة.",
        "total": "الإجمالي",
        "of_base_one": "من واحد",
        "of_base_two": "من اثنين",
        "of_base_few": "من {{count}}",
        "of_base_many": "من {{count}}",
        "of_base_other": "من {{count}}",
        "truncated": "تُعرض أول {{count}} صف. أضف مرشّحات أو صدّر إلى CSV للحصول على الكل."
    },
    "schedules": {
        "title": "التقارير المجدولة",
        "subtitle": "تقارير تُنتج نفسها وتُرسل نفسها.",
        "new": "جدولة جديدة",
        "empty": "لا توجد جدولة بعد.",
        "report": "التقرير",
        "when": "التوقيت",
        "frequency": "الدورية",
        "time": "الوقت",
        "day": "اليوم",
        "day_of_month": "يوم الشهر",
        "day_of_month_help": "الجدولة على اليوم ٣١ تعمل في فبراير أيضاً، في آخر يوم منه.",
        "format": "الصيغة",
        "recipients": "الإرسال إلى",
        "next": "التشغيل القادم",
        "paused": "متوقفة",
        "narrative": "ملخص مكتوب",
        "narrative_help": "التقرير العربي يحمل ملخصاً مكتوباً بالعربية، لا ترجمة لنص إنجليزي.",
        "skip_empty": "لا تُرسل عندما لا يوجد ما يُبلَّغ عنه",
        "skip_empty_help": "التقرير الذي يصل فارغاً كل أسبوع يتعلّم الناس حذفه دون قراءة."
    },
    "frequencies": {
        "daily": "يومي",
        "weekly": "أسبوعي",
        "monthly": "شهري"
    },
    "runs": {
        "title": "سجل التقارير",
        "subtitle": "كل ما أُنتج، وكل ما أخفق.",
        "empty": "لم يُنتج شيء بعد.",
        "report": "التقرير",
        "status": "الحالة",
        "trigger": "بدأه",
        "rows": "الصفوف",
        "duration": "استغرق",
        "when": "التوقيت",
        "expired": "انتهت صلاحية الملف",
        "scope": "النطاق: {{scope}}",
        "statuses": {
            "running": "قيد التشغيل",
            "completed": "مكتمل",
            "failed": "أخفق"
        },
        "triggers": {
            "manual": "شخص",
            "scheduled": "الجدولة"
        }
    }
}
